import * as _ from "lodash";

const sortPrestationsLowestToHighestPrice = (prestations) => {
	if (prestations.length === 0) return prestations;
	const sorted = [...prestations];
	sorted.sort((a, b) => {
		return (
			parseInt(a.variants[0].pricePerLogement) -
			parseInt(b.variants[0].pricePerLogement)
		);
	});
	return sorted;
};

const removeDuplicates = (prestations) => {
	prestations.forEach((prest) => {
		const map = {};
		prest.variants.forEach((variant) => {
			map[variant.id] = variant;
		});
		prest.variants = Object.values(map).sort(
			(a, b) => a.pricePerLogement > b.pricePerLogement
		);
	});
	return prestations;
};

export default {
	prestations: (state) => {
		let prestations = [];

		if (state.loading) return prestations;

		// get prestation arrays
		const initialPrestations = _.cloneDeep(state.initialPrestationsArray);
		// get maps
		const availabilityPrestationsMap = _.cloneDeep(
			state.prestMaps.seAvailabilities[state.packCode]
		);
		const quotePrestationsMap = _.cloneDeep(
			state.prestMaps.quotePrices[state.packCode] || null
		);

		// Check for availability.
		// The same prestation can be in several packages, so
		// an availability prestation is enriched with initial prestation info
		if (
			!availabilityPrestationsMap ||
			Object.keys(availabilityPrestationsMap).length === 0
		) {
			return prestations;
		}

		try {
			prestations = initialPrestations
				.map((initialPrest) => {
					initialPrest["criteriasSet"] = new Set(initialPrest.criterias);
					initialPrest["variants"] = [];

					// check if prestationId matches prestIdSource
					Object.values(availabilityPrestationsMap).forEach((availPrest) => {
						availPrest["totalMaxCapacity"] =
							availPrest.quantity * availPrest.maxCapacity;

						// if source id matches initial prest id
						if (initialPrest.prestationId === availPrest.prestIdSource) {
							initialPrest["variants"].push(availPrest);
						}
					});

					// for variants from previous loop, add variants that have the same prestIdFusion but different unique id (pv flex case)
					const variantsToAdd = [];
					initialPrest["variants"].forEach((variant) => {
						const sameFusionIdPrestation = Object.values(
							availabilityPrestationsMap
						).find((availPrest) => {
							return (
								availPrest.prestIdFusion === variant.prestIdFusion &&
								availPrest.id !== variant.id
							);
						});
						if (sameFusionIdPrestation)
							variantsToAdd.push(sameFusionIdPrestation);
					});

					initialPrest["variants"] = [
						...initialPrest["variants"],
						...variantsToAdd,
					];
					initialPrest["variants"] = initialPrest["variants"].filter((_) => _);

					if (initialPrest["variants"].length === 0) {
						return;
					}
					return initialPrest;
				})
				.filter((_) => _);
		} catch (err) {
			console.log(`@@@@ failed to enrich with availabilities`);
			console.error(err);
		}

		// update / enrich with quote prices
		if (!quotePrestationsMap || Object.keys(quotePrestationsMap).length === 0) {
			// console.log(`---- did not enrich with quotes`)
		} else {
			try {
				prestations = prestations
					.map((prest) => {
						Object.values(quotePrestationsMap).forEach((quotePrest) => {
							quotePrest["totalMaxCapacity"] =
								quotePrest.quantity * quotePrest.maxCapacity;
							prest["variants"] = prest["variants"]
								.map((variant) => {
									if (variant.id === quotePrest.id) {
										Object.keys(variant).forEach((field) => {
											if (quotePrest[field]) {
												variant[field] = quotePrest[field];
											} else {
												delete variant[field];
											}
										});
									}
									return variant;
								})
								.filter((_) => _);
						});
						return prest;
					})
					.filter((_) => _);
			} catch (err) {
				console.log(`@@@@ failed to enrich with quotes`);
				console.error(err);
			}
		}

		prestations = removeDuplicates(prestations);
		prestations = sortPrestationsLowestToHighestPrice(prestations);
		// prestations = process_CS_packages(prestations, state.content)

		return prestations;
	},

	variants: (state, getters) => {
		const prestations = getters.prestations;
		let variants = [];

		prestations.forEach((prest) => {
			variants = [...variants, ...prest.variants];
		});

		return variants;
	},

	cheapestPrestationIndex: (state, getters) => {
		const prestations = getters.prestations;
		let cheapestPrestationIndex;
		let currentCheapestPrice;
		prestations.forEach((prest, prest_i) => {
			prest.variants.forEach((variant) => {
				const pricePerLogement = variant.pricePerLogement;
				if (!currentCheapestPrice) {
					cheapestPrestationIndex = prest_i;
					currentCheapestPrice = pricePerLogement;
				} else if (currentCheapestPrice > pricePerLogement) {
					currentCheapestPrice = pricePerLogement;
				}
			});
		});

		return cheapestPrestationIndex;
	},
};
